// extracted by mini-css-extract-plugin
module.exports = {"policy_wrapper":"LegislativeSessionItem_policy_wrapper__33ebc","policy":"LegislativeSessionItem_policy__B--9o","mark":"LegislativeSessionItem_mark__tCd5C"};